import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_01dc8496 from 'nuxt_plugin_recaptcha_01dc8496' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_1254e4e2 from 'nuxt_plugin_nuxtuseragent_1254e4e2' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuetypedreactive_5ee82e8f from 'nuxt_plugin_vuetypedreactive_5ee82e8f' // Source: ./vue-typed-reactive.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_deviceplugin_7007b3d1 from 'nuxt_plugin_deviceplugin_7007b3d1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_axioscookies_0ca7defc from 'nuxt_plugin_axioscookies_0ca7defc' // Source: ../src/plugins/axios-cookies (mode: 'server')
import nuxt_plugin_logger_52e3bef4 from 'nuxt_plugin_logger_52e3bef4' // Source: ../src/plugins/logger (mode: 'all')
import nuxt_plugin_axioslogger_15d31bf2 from 'nuxt_plugin_axioslogger_15d31bf2' // Source: ../src/plugins/libs/axios-logger (mode: 'all')
import nuxt_plugin_dayjs_46ebab1a from 'nuxt_plugin_dayjs_46ebab1a' // Source: ../src/plugins/libs/dayjs (mode: 'all')
import nuxt_plugin_portalvue_0548cee0 from 'nuxt_plugin_portalvue_0548cee0' // Source: ../src/plugins/libs/portal-vue (mode: 'all')
import nuxt_plugin_veevalidate_d498d2d0 from 'nuxt_plugin_veevalidate_d498d2d0' // Source: ../src/plugins/libs/vee-validate (mode: 'all')
import nuxt_plugin_vuebarcode_97b876a4 from 'nuxt_plugin_vuebarcode_97b876a4' // Source: ../src/plugins/libs/vue-barcode (mode: 'all')
import nuxt_plugin_vueawesomeswiper_752a7d98 from 'nuxt_plugin_vueawesomeswiper_752a7d98' // Source: ../src/plugins/libs/vue-awesome-swiper (mode: 'all')
import nuxt_plugin_vueslidercomponent_70a78aa3 from 'nuxt_plugin_vueslidercomponent_70a78aa3' // Source: ../src/plugins/libs/vue-slider-component (mode: 'all')
import nuxt_plugin_apiaxios_150a884d from 'nuxt_plugin_apiaxios_150a884d' // Source: ../src/plugins/api-axios (mode: 'all')
import nuxt_plugin_errorhandler_1dde38cf from 'nuxt_plugin_errorhandler_1dde38cf' // Source: ../src/plugins/error-handler (mode: 'all')
import nuxt_plugin_constants_56a5fa99 from 'nuxt_plugin_constants_56a5fa99' // Source: ../src/plugins/constants (mode: 'all')
import nuxt_plugin_enums_34feac48 from 'nuxt_plugin_enums_34feac48' // Source: ../src/plugins/enums (mode: 'all')
import nuxt_plugin_redirect_7657855c from 'nuxt_plugin_redirect_7657855c' // Source: ../src/plugins/redirect (mode: 'all')
import nuxt_plugin_redirectFromOldSystem_20a57b0c from 'nuxt_plugin_redirectFromOldSystem_20a57b0c' // Source: ../src/plugins/redirectFromOldSystem (mode: 'all')
import nuxt_plugin_persistState_0b52b993 from 'nuxt_plugin_persistState_0b52b993' // Source: ../src/plugins/persistState (mode: 'client')
import nuxt_plugin_onAuthChanged_098f2cd7 from 'nuxt_plugin_onAuthChanged_098f2cd7' // Source: ../src/plugins/onAuthChanged (mode: 'client')
import nuxt_plugin_anchorLink_3d084445 from 'nuxt_plugin_anchorLink_3d084445' // Source: ../src/plugins/anchorLink (mode: 'client')
import nuxt_plugin_clickoutside_00e89f0b from 'nuxt_plugin_clickoutside_00e89f0b' // Source: ../src/plugins/directives/click-outside (mode: 'client')
import nuxt_plugin_karte_346178d2 from 'nuxt_plugin_karte_346178d2' // Source: ../src/plugins/karte (mode: 'client')
import nuxt_plugin_nuxtServerInit_bc090168 from 'nuxt_plugin_nuxtServerInit_bc090168' // Source: ../src/plugins/nuxtServerInit (mode: 'server')
import nuxt_plugin_cookieOptimizer_1dcb4e0a from 'nuxt_plugin_cookieOptimizer_1dcb4e0a' // Source: ../src/plugins/cookieOptimizer (mode: 'client')
import nuxt_plugin_dataLayer_59149911 from 'nuxt_plugin_dataLayer_59149911' // Source: ../src/plugins/dataLayer (mode: 'client')
import nuxt_plugin_treasureData_5b42316f from 'nuxt_plugin_treasureData_5b42316f' // Source: ../src/plugins/treasureData (mode: 'client')
import nuxt_plugin_collectCodeTag_a475024e from 'nuxt_plugin_collectCodeTag_a475024e' // Source: ../src/plugins/collectCodeTag (mode: 'client')
import nuxt_plugin_recommendTracking_59dc96dd from 'nuxt_plugin_recommendTracking_59dc96dd' // Source: ../src/plugins/recommendTracking (mode: 'client')
import nuxt_plugin_gtmEvents_2bd66fa3 from 'nuxt_plugin_gtmEvents_2bd66fa3' // Source: ../src/plugins/gtmEvents (mode: 'client')
import nuxt_plugin_silverEgg_73a8a1fc from 'nuxt_plugin_silverEgg_73a8a1fc' // Source: ../src/plugins/silverEgg (mode: 'client')
import nuxt_plugin_firstPurchasePromotion_31a1cac8 from 'nuxt_plugin_firstPurchasePromotion_31a1cac8' // Source: ../src/plugins/firstPurchasePromotion (mode: 'client')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"}],"script":[{"src":"https:\u002F\u002Fcdn-apac.onetrust.com\u002Fscripttemplates\u002FotSDKStub.js","charset":"UTF-8","data-domain-script":"893b3255-8646-47f2-aea4-1a551a6e3724"},{"hid":"onetrustWovnIgnore","innerHTML":"function OptanonWrapper() { document.getElementById('onetrust-consent-sdk').setAttribute('wovn-ignore',''); }"},{"src":"\u002F_api\u002Fv1\u002Fpolyfill.js?hash=a2e3c76ae7b3d209dc01","defer":true},{"src":"https:\u002F\u002Fajax.googleapis.com\u002Fajax\u002Flibs\u002Fjquery\u002F3.5.1\u002Fjquery.min.js","async":true},{"src":"https:\u002F\u002Fstatic.staff-start.com\u002Fjs\u002Ftrack\u002Fv3.0\u002Fstaffstart.min.js","async":true},{"src":"https:\u002F\u002Fcdn-blocks.karte.io\u002F1528546da7ee438312a80f7b88a391a0\u002Fbuilder.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T2KVQN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"onetrustWovnIgnore":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"link":[],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T2KVQN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_01dc8496 === 'function') {
    await nuxt_plugin_recaptcha_01dc8496(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_1254e4e2 === 'function') {
    await nuxt_plugin_nuxtuseragent_1254e4e2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetypedreactive_5ee82e8f === 'function') {
    await nuxt_plugin_vuetypedreactive_5ee82e8f(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7007b3d1 === 'function') {
    await nuxt_plugin_deviceplugin_7007b3d1(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_axioscookies_0ca7defc === 'function') {
    await nuxt_plugin_axioscookies_0ca7defc(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_52e3bef4 === 'function') {
    await nuxt_plugin_logger_52e3bef4(app.context, inject)
  }

  if (typeof nuxt_plugin_axioslogger_15d31bf2 === 'function') {
    await nuxt_plugin_axioslogger_15d31bf2(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_46ebab1a === 'function') {
    await nuxt_plugin_dayjs_46ebab1a(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_0548cee0 === 'function') {
    await nuxt_plugin_portalvue_0548cee0(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_d498d2d0 === 'function') {
    await nuxt_plugin_veevalidate_d498d2d0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebarcode_97b876a4 === 'function') {
    await nuxt_plugin_vuebarcode_97b876a4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueawesomeswiper_752a7d98 === 'function') {
    await nuxt_plugin_vueawesomeswiper_752a7d98(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslidercomponent_70a78aa3 === 'function') {
    await nuxt_plugin_vueslidercomponent_70a78aa3(app.context, inject)
  }

  if (typeof nuxt_plugin_apiaxios_150a884d === 'function') {
    await nuxt_plugin_apiaxios_150a884d(app.context, inject)
  }

  if (typeof nuxt_plugin_errorhandler_1dde38cf === 'function') {
    await nuxt_plugin_errorhandler_1dde38cf(app.context, inject)
  }

  if (typeof nuxt_plugin_constants_56a5fa99 === 'function') {
    await nuxt_plugin_constants_56a5fa99(app.context, inject)
  }

  if (typeof nuxt_plugin_enums_34feac48 === 'function') {
    await nuxt_plugin_enums_34feac48(app.context, inject)
  }

  if (typeof nuxt_plugin_redirect_7657855c === 'function') {
    await nuxt_plugin_redirect_7657855c(app.context, inject)
  }

  if (typeof nuxt_plugin_redirectFromOldSystem_20a57b0c === 'function') {
    await nuxt_plugin_redirectFromOldSystem_20a57b0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistState_0b52b993 === 'function') {
    await nuxt_plugin_persistState_0b52b993(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onAuthChanged_098f2cd7 === 'function') {
    await nuxt_plugin_onAuthChanged_098f2cd7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_anchorLink_3d084445 === 'function') {
    await nuxt_plugin_anchorLink_3d084445(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_00e89f0b === 'function') {
    await nuxt_plugin_clickoutside_00e89f0b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_karte_346178d2 === 'function') {
    await nuxt_plugin_karte_346178d2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtServerInit_bc090168 === 'function') {
    await nuxt_plugin_nuxtServerInit_bc090168(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieOptimizer_1dcb4e0a === 'function') {
    await nuxt_plugin_cookieOptimizer_1dcb4e0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dataLayer_59149911 === 'function') {
    await nuxt_plugin_dataLayer_59149911(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_treasureData_5b42316f === 'function') {
    await nuxt_plugin_treasureData_5b42316f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_collectCodeTag_a475024e === 'function') {
    await nuxt_plugin_collectCodeTag_a475024e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recommendTracking_59dc96dd === 'function') {
    await nuxt_plugin_recommendTracking_59dc96dd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmEvents_2bd66fa3 === 'function') {
    await nuxt_plugin_gtmEvents_2bd66fa3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_silverEgg_73a8a1fc === 'function') {
    await nuxt_plugin_silverEgg_73a8a1fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firstPurchasePromotion_31a1cac8 === 'function') {
    await nuxt_plugin_firstPurchasePromotion_31a1cac8(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
